module.exports = __webpack_public_path__ + "img/Ara.d86bcb08.png";